import { FormGroup } from '@angular/forms';
import {
    LogicStepParameter,
    LogicStepParameterProperty,
    LogicStepParameterType,
    LookupObject,
} from '@wdx/shared/utils';
import {
    ActiveFieldState,
    BaseSegmentedControlStrategy,
} from './base-segmented-control-strategy.service';
import { Injectable } from '@angular/core';

@Injectable()
export class RelativePartyStrategy extends BaseSegmentedControlStrategy {
    private referenceParam?: LogicStepParameterProperty;
    private typeParam?: LogicStepParameterProperty;
    private partyParam?: LogicStepParameterProperty;

    override init(parameter: LogicStepParameter, formGroup: FormGroup): void {
        this.referenceParam = parameter.properties?.find(
            (p) => p.code === 'Reference',
        );
        this.typeParam = parameter.properties?.find((p) => p.code === 'Type');
        this.partyParam = parameter;
        super.init(parameter, formGroup);
    }

    protected resolveKind(kind: string): ActiveFieldState {
        switch (kind) {
            case 'Code':
                return {
                    Reference: {
                        ...this.referenceParam,
                        kind: LogicStepParameterType.Primitive,
                        properties: [this.typeParam],
                        onChange: (formGroup, val?: LookupObject) => {
                            formGroup
                                .get(this.referenceParam.code)
                                .setValue(val?.id, { emitEvent: false });
                            formGroup
                                .get(this.typeParam.code)
                                .setValue(val?.lookupType);
                        },
                        getValue: (formGroup) => {
                            return {
                                id: formGroup.get(this.referenceParam.code)
                                    .value,
                                lookupType: formGroup.get(this.typeParam.code)
                                    .value,
                            };
                        },
                    },
                };
            case 'Relative':
                return {
                    Reference: {
                        ...this.referenceParam,
                        options: this.partyParam.options,
                    },
                };

            default:
                return {};
        }
    }
}
